import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CART_PAGE_VIEW_ALLOWED_METHODS } from './cart-page-view.constants';

export function cartPageViewInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const isCartPageViewRequest: boolean = CART_PAGE_VIEW_ALLOWED_METHODS.some((method: string): boolean =>
    req.url.includes(method)
  );

  if (!isCartPageViewRequest) {
    return next(req);
  }

  const injector: Injector = inject(Injector);

  return from(import('./cart-page-view.handler')).pipe(
    switchMap(({ applyCartPageView }) => next(applyCartPageView(req, injector)))
  );
}
